import Api from "../api/Api";

class Filter {
  constructor(token, searchFilterGroup) {
    this.token = token;
    this.searchFilterGroup = searchFilterGroup;
    this._initProps();
    this._init();
  }

  _initProps() {
    this.tagsData = [];
    this.urlParams = new URLSearchParams(window.location.search);
    this.queryParams = this.urlParams.get('q');
    this.query = `{
          products(first: 250, query: "${this.queryParams}") {
            edges {
              node {
                tags
              }
            }
          }
        }`;
  }

  async _init() {
    try {
      const data = await Api.post('/api/graphql', {
        headers: {
          'X-Shopify-Storefront-Access-Token': this.token,
          'Content-Type': 'application/graphql',
        },
        async: true,
        crossDomain: true,
        body: this.query,
        referrerPolicy: 'strict-origin-when-cross-origin',
      });
      this.tagsData = this._getUniqueTags(data.data.products.edges);
      let tagsDataAssoc = this._getAssocData(this.tagsData);
      tagsDataAssoc = this._sortTagsData(tagsDataAssoc);
      const filtersHtml = this._getMenuHtml(tagsDataAssoc);

      $('#searchMenu').html('<div class="card">' + filtersHtml + '</div>');
      $('.collection-drawer__inner').html(filtersHtml);

      $('button[data-action="clear-tags"]').on('click', function () {
        $('div.checkbox-wrapper > input.checkbox').prop('checked', false);
        $('li.collection__filter-checkbox a.size-selected').removeClass('size-selected');
      });

      $('div.search-filter').on('click', 'button.collection__active-filter-cross', function () {
          let data_tag = $(this).data('tag');
          let input = $('input.checkbox[data-tag="' + data_tag + '"]');
          input.prop('checked', false);
          input.parent('div').parent('a').attr('class', '');
      });

      let filterLinks = Array.from(document.querySelectorAll('#mobile-collection-filters li.collection__filter-checkbox a'));
      this._addEventListerForData(filterLinks, 'click');
      let filterLinksDesktop = Array.from(document.querySelectorAll('#searchMenu li.collection__filter-checkbox a'));
      this._addEventListerForData(filterLinksDesktop, 'change');
    } catch (e) {
      console.error('Get tags failed: ', e);
    }
  }

  _addEventListerForData(data, event) {
    data.forEach(link => {
      link.addEventListener(event, () => {
        link.classList.toggle('size-selected');
      });
    });
  }

  _getUniqueTags(data) {
    let tagsData = [];
    data.forEach(function (element) {
      for (const str of element.node.tags) {
        if (!tagsData.includes(str)) {
          tagsData.push(str);
        }
      }
    });
    return tagsData;
  }

  _getAssocData(tagsData) {
    let tagsDataAssoc = [];
    tagsData.forEach(function (element) {
      let filterElement = element.split('_');
      if(filterElement.length === 2) {
        if(typeof tagsDataAssoc[filterElement[0]] === 'undefined') {
          tagsDataAssoc[filterElement[0]] = [filterElement[1]];
        } else {
          tagsDataAssoc[filterElement[0]].push(filterElement[1]);
        }
      }
    });
    return tagsDataAssoc;
  }

  _getMenuHtml(tagsDataAssoc) {
    const self = this;
    let filtersHtml = '<div class="card__section card__section--tight">';
    filtersHtml += '<p class="card__title--small heading">Filters</p>';
    filtersHtml += '<div class="collection__active-filters"></div>';
    filtersHtml += '<div class="collection__filter-group-list collection__filter-group-list--ordered">';
    let linkId = 0;
    Object.keys(tagsDataAssoc).forEach(function (groupName) {
      filtersHtml += `<div class="collection__filter-group ">
            <button class="collection__filter-group-name link link--secondary text--strong" data-action="toggle-collapsible" aria-controls="filter-${linkId}" data-close-siblings="false" data-collapsible-force-overflow="true"
                        aria-expanded="false">${groupName}<svg class="icon icon--arrow-bottom" viewBox="0 0 12 8" role="presentation">
                        <path stroke="currentColor" stroke-width="2" d="M10 2L6 6 2 2" fill="none" stroke-linecap="square"></path>
                    </svg>
                </button>
                <div id="filter-${linkId}" class="collection__filter-collapsible" aria-hidden="true">
                    <ul class="collection__filter-checkbox-list ${groupName === 'size' ? 'size-wrapper' : ''}">`;

      filtersHtml += self._getLiTags(tagsDataAssoc, groupName, linkId);

      filtersHtml += `</ul>
              </div>
          </div>`;
      linkId++;
    });

    filtersHtml += '</div>';
    filtersHtml += '</div>';

    return filtersHtml;
  }

  _getLiTags(tagsDataAssoc, groupName, linkId) {
    let filtersHtml = '';
    const self = this;
    tagsDataAssoc[groupName].forEach(function (tag) {
      let tagLower = tag.toLowerCase().replace(/ /g, '-');
      let groupNameWithTagLower =
        groupName.toLowerCase().replace(/ /g, '-') + '_' + tagLower;
      filtersHtml += `<li class="collection__filter-checkbox">
                        <a>
                          <div class="checkbox-wrapper">
                              <input type="checkbox" class="checkbox" id="filter-${linkId}-tag-${groupNameWithTagLower}" name="tag-category"
                                     data-action="toggle-tag" data-tag="${groupNameWithTagLower}" data-tag-user="${tag}">
                              <svg class="icon icon--check" viewBox="0 0 24 24" role="presentation">
                                  <path fill="currentColor" d="M9 20l-7-7 3-3 4 4L19 4l3 3z"></path>
                              </svg>
                          </div>
                          <label for="filter-${linkId}-tag-${groupNameWithTagLower}" ${(self.isStringCustom(tag) && groupName === 'size') ? 'style="font-size: 0.7rem"' : ''} ${groupName === 'size' ? 'class="value-wrapper"' : ''}>
                          ${
                            !Number.isInteger(parseFloat(tag)) && !self.isStringCustom(tag) && groupName  === 'size' 
                            ? `<span class="main-value">${Math.trunc(tag)}</span><span class="half-value"><span>1</span><hr /><span>2</span></span>` 
                            : tag
                          }
                           </label>
                        </a>
                      </li>`;
    });

    return filtersHtml;
  }

  _sortTagsData(tagsDataAssoc) {
    let tagsDataAssocSort = [];
    const self = this;
    const tagsDataKeys = Object.keys(tagsDataAssoc);
    tagsDataKeys.sort((a, b) => {
      if (this.searchFilterGroup.indexOf(a.toLowerCase()) == -1 && this.searchFilterGroup.indexOf(b.toLowerCase()) == -1) return -1;
      if (this.searchFilterGroup.indexOf(a.toLowerCase()) == -1) return 1;
      if (this.searchFilterGroup.indexOf(b.toLowerCase()) == -1) return -1;
      return (
        this.searchFilterGroup.indexOf(a.toLowerCase()) -
        this.searchFilterGroup.indexOf(b.toLowerCase())
      );
    });

    tagsDataKeys.forEach(function (element) {
      if (element == 'size') {
        tagsDataAssocSort[element] = self.sortNumbers(tagsDataAssoc[element]);
      } else {
        tagsDataAssocSort[element] = tagsDataAssoc[element];
      }
    });
    return tagsDataAssocSort;
  }

  isStringCustom(value) {
    return parseFloat(value).toString().length !== value.toString().length;
  }

  sortNumbers(data) {
    var collator = new Intl.Collator(undefined, {numeric: true, sensitivity: 'base'});
    return data.sort(collator.compare);
  }
}

export default Filter;
